"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryProperty = exports.TelemetryEvents = void 0;
var TelemetryEvents;
(function (TelemetryEvents) {
    TelemetryEvents["Generate"] = "generate";
    TelemetryEvents["EnsureYoStart"] = "ensure-yo-start";
    TelemetryEvents["EnsureYo"] = "ensure-yo";
    TelemetryEvents["EnsureSharepointGeneratorStart"] = "ensure-sharepoint-generator-start";
    TelemetryEvents["EnsureSharepointGenerator"] = "ensure-sharepoint-generator";
    TelemetryEvents["UseNotRecommendedVersion"] = "use-not-recommended-spfx-version";
    TelemetryEvents["CheckAddWebPartPackage"] = "check-add-web-part-package";
    TelemetryEvents["LearnMoreVersionMismatch"] = "learn-more-version-mismatch";
    TelemetryEvents["GetSpfxNodeVersionFailed"] = "get-spfx-node-version-failed";
})(TelemetryEvents || (exports.TelemetryEvents = TelemetryEvents = {}));
var TelemetryProperty;
(function (TelemetryProperty) {
    TelemetryProperty["EnsureYoReason"] = "ensure-yo-reason";
    TelemetryProperty["EnsureSharepointGeneratorReason"] = "ensure-sharepoint-generator-reason";
    TelemetryProperty["SPFxSolution"] = "spfx-solution";
    TelemetryProperty["ConfirmAddWebPartResult"] = "confirm-add-web-part-result";
    TelemetryProperty["PackageSource"] = "package-source";
    TelemetryProperty["UserAction"] = "user-action";
})(TelemetryProperty || (exports.TelemetryProperty = TelemetryProperty = {}));
//# sourceMappingURL=telemetryEvents.js.map